import { CloseOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, FormInstance, Modal, Select, TreeSelect, Upload } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect, useRef, useState } from "react";
import useLoading from "../../hook/useLoading";
import useToast from "../../hook/useToast";
import './style.scss';
const { Dragger } = Upload;

import { FormProps } from "antd/lib";
import * as IssuedCardsApi from '../../api/rank/issuedCardApi';
import * as RankApi from '../../api/rank/rankApi';
import * as SelectOptionApi from '../../api/selectOptions/selectOptionsApi';
import { buildTreeData, convertGroupValueToTreeV2 } from "../../api/unit/unitApi";
import useDebounce from "../../hook/useDebounce";
import { fommatSelectOptionV2, formatDateV2 } from "../../until";

interface CustomerFilterSearch {
  searchProfession?: string
  searchPersonContact?: string
  searchPolicies?: string
}


export interface InforSelectedCodeCustomer {
  value?: string
  label?: string
  id?: number
  phone?: string
}


interface ModalProps {
  isOpen: boolean
  dataRank: RankApi.IRank[]
  selectedRowKeys: React.Key[]
  closeModal: () => void
  setSelectedRowKeys: React.Dispatch<React.SetStateAction<React.Key[]>>
  confirmModalAdd: (isSucces: boolean, errorMesses?: string) => void
}
const ModalCardIssuance: React.FC<ModalProps> = ({
  isOpen,
  selectedRowKeys,
  dataRank,
  closeModal, setSelectedRowKeys, confirmModalAdd
}) => {


  const inputRef = useRef<FormInstance>(null);
  const pushToast = useToast();
  const pushLoading = useLoading();

  const [form] = useForm();
  const selectedPolicies = Form.useWatch('listCarePolicies', form) ?? []

  const rankId = Form.useWatch('rank', form)

  const [selectedRank, setSelectedRank] = useState<number | undefined>(undefined);
  const [policyRows, setPolicyRows] = useState<number[]>([Date.now()]);
  const [benefitOptions, setBenefitOptions] = useState<any[]>([]);
  const [searchFilters, setSearchFilters] = useState<CustomerFilterSearch>();

  const [dataBenefitRank, setDataBenefitRank] = useState<RankApi.IInfoRank>()

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const handleChange = (value: number) => {
    setSelectedRank(value);
  };

  const addPolicyRow = () => {
    setPolicyRows(prev => [...prev, Date.now()]);
  };

  const removePolicyRow = (index: number) => {
    setPolicyRows(prev => prev.filter((_, i) => i !== index));
    const policies: (number | undefined)[] = form.getFieldValue('policies') ?? [];
    form.setFieldValue('policies', policies.filter((_, i) => i !== index));
  };



  const onFinish: FormProps["onFinish"] = async (values: any) => {
    // const groupIdPolicies = dataBenefitRank?.carePolicies

    const groupIdPolicies = [
      ...new Set([
        ...(values.listCarePolicies || []),
        ...(dataBenefitRank?.carePolicies?.map(item => item.id) || []),
      ]),
    ];
    const expirationDateTmp = values.expirationDate ? formatDateV2(values.expirationDate) : undefined
    const result = await IssuedCardsApi.addCardIssuance(selectedRowKeys.map(Number), groupIdPolicies, formatDateV2(values.releaseDate), expirationDateTmp, values.rank);
    if (result?.status) {
      setSelectedRowKeys([])

      confirmModalAdd?.(true)

    } else {
      //  confirmModalAdd?.(false, result.message)
      pushToast(result.message, 'error')
      confirmModalAdd?.(false, result.message)


    }
  };

  const getListCarePolicyBenefitsTree = useDebounce(async () => {
    const result = await SelectOptionApi.getListCarePolicyBenefitsTree(searchFilters?.searchPolicies, rankId)
    if (result?.status) {
      setBenefitOptions(convertGroupValueToTreeV2(result.data))
    }
  }, 500)


  const getInfoRank = async () => {
    if (!rankId) return
    const result = await RankApi.getInfoRank(rankId);
    if (result.status) {
      setDataBenefitRank(result.data)
    } else {
      pushToast(result.message, "error", 2000)
    }
  }

  useEffect(() => {
    getInfoRank()
    form.setFieldsValue({
      listCarePolicies: [],
    });

    setPolicyRows([]);
  }, [rankId])


  useEffect(() => {
    getListCarePolicyBenefitsTree()
  }, [rankId, searchFilters?.searchPolicies])

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
      // setIsFileError(false)
      // setIsDowloadLog(true)
      // setTextError("")
      // setIsUploadList(false)
      // setDataExcel([])
      setDataBenefitRank(undefined)
      form.setFieldsValue({
        listCarePolicies: [],
      });

      setPolicyRows([]);
    }

  }, [isOpen])
  return (
    <Modal
      title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
        <span className="text-base text-344054 fw-500 font-medium">Tải lên danh sách</span>
        <CloseOutlined className="text-base text-8B8B8B"
          onClick={closeModal}
        />
      </div>}
      onCancel={closeModal}
      open={isOpen}
      centered
      className="w-modal modal-content ant-modal-size m-none-header"
      closeIcon={false}
      footer={
        <div className="custom-page-css w-full flex items-center justify-end p-4 ">
          <Button
            type="primary"
            onClick={() => form.submit()}
          >
            Tạo
          </Button>
        </div>
      }
    >
      <Form
        form={form}
        className="form-block p-4"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"

      >
        <div className="title-content">Xác nhận phát hành {selectedRowKeys.length} thẻ thành viên</div>
        <div className="custom-page-css flex w-full gap-2">
          <Form.Item
            label={<span className="">Ngày phát hành<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
            name="releaseDate"
            rules={[{ required: true, message: 'Vui lòng chọn ngày phát hành!' }]}
          >
            <DatePicker
              placeholder="Ngày phát hành"
              format={'DD/MM/YYYY'}
              className="custom-input-date w-full"
            />
          </Form.Item>
          <Form.Item
            label="Ngày hết hạn"
            name="expirationDate"
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const releaseDate = getFieldValue("releaseDate");

                  // Không nhập ngày hết hạn thì bỏ qua
                  if (!value || !releaseDate) {
                    return Promise.resolve();
                  }

                  if (value.isAfter(releaseDate, "day")) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error("Ngày hết hạn phải lớn hơn ngày phát hành!")
                  );
                },
              }),
            ]}
          >
            <DatePicker
              placeholder="Ngày hết hạn"
              format={'DD/MM/YYYY'}
              className="custom-input-date w-full"
            />
          </Form.Item>
        </div>

        <Form.Item
          label="Hạng thẻ"
          name="rank"
        >
          <Select
            className='custom-page-css border rounded overflow-hidden'
            placeholder="Hạng thẻ"
            onChange={handleChange}
            value={selectedRank}
            options={fommatSelectOptionV2(dataRank)}
          />
        </Form.Item>
        <div className="custom-page-css flex flex-col gap-1">
          {dataBenefitRank?.carePolicies?.map(item =>

            <span>{item.title}</span>
          )}
        </div>

        {policyRows.map((rowId, index) => (
          <div key={rowId} className="policy-row">
            <DeleteOutlined
              className="policy-delete-icon"
              onClick={() => removePolicyRow(index)}
            />
            <Form.Item
              className="custom-page-css w-full overflow-hidden"
              name={['listCarePolicies', index]}
              rules={[
                {
                  validator(_, value) {
                    if (dataBenefitRank && dataBenefitRank?.carePolicies?.length > 0) {
                      return Promise.resolve();
                    }

                    if (value !== undefined && value !== null) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error("Vui lòng chọn chính sách CSKH!")
                    );
                  },
                },
              ]}
              style={{ flex: 1, marginBottom: 0 }}
            >
              {/* <Select
                  className='custom-page-css border rounded overflow-hidden'
                  placeholder="Chọn chính sách CSKH"
                
                  options={benefitOptions}
                /> */}
              <TreeSelect
                className='custom-page-css w-full border rounded overflow-hidden text-truncate'

                showSearch
                placeholder="Chọn chính sách CSKH"
                allowClear
                // value={dataFilterTmp.group}
                treeDefaultExpandAll={false}
                treeData={buildTreeData(
                  benefitOptions,
                  selectedPolicies,
                  form.getFieldValue(['listCarePolicies', index])
                )}
                filterTreeNode={false}

                onSearch={(value) => setSearchFilters({ ...searchFilters, searchPolicies: value })}
                onBlur={() => setSearchFilters({ ...searchFilters, searchPolicies: '' })}
              // onSearch={(value) => setSearchFilter({ ...searchFilter, searchGroup: value })}
              // onBlur={() => setSearchFilter({ ...searchFilter, searchGroup: '' })}
              // onChange={(e) => setDataFilterTmp({ ...dataFilterTmp, group: e !== undefined ? e : undefined })}
              // onClear={() => setDataFilterTmp({ ...dataFilterTmp, group: undefined })}
              />
            </Form.Item>
          </div>
        ))}

        <Button
          type="dashed"
          className="btn-add-policy"
          onClick={addPolicyRow}
          icon={<PlusOutlined />}
        >
          Thêm chính sách CSKH
        </Button>

      </Form>



    </Modal>
  )
}
export default ModalCardIssuance
